<template>
  <div class='list'>
    <el-form :model='dioForm' label-width='120px' v-if='!coordinator'>
      <el-row>
        <el-col :span='12' v-for='item in baseMsgArray' :key='item.key'>
          <el-form-item :label='$t(item.text)'>
            <template v-if="item.key === 'isHeart'">
                            <span v-if='!isEdit'>
                                {{ heartFn(item.key) }}
                            </span>
              <el-checkbox v-else v-model="dioForm['isHeart']" :true-label='1' :false-label='0'>
              </el-checkbox>
            </template>
            <template v-else-if="item.key === 'location'">
                            <span v-if='!isEdit'>
                            {{  selectChange(item.key,locationId) }}
                            </span>

              <el-select v-else
                v-model="locationId"
                :placeholder="$t('integration.please_select')"
                style="width: 200px"
              >
                <!-- 循环渲染选项 -->
                <el-option
                  v-for="loc in locationList"
                  :key="loc.id"
                  :label="loc.name"
                  :value="loc.id"
                ></el-option>
              </el-select>
            </template>
            <template v-else-if="item.key === 'group'">
                            <span v-if='!isEdit'>
                                {{  selectChange(item.key,groupId) }}
                            </span>

              <el-select v-else
                v-model="groupId"
                :placeholder="$t('integration.please_select')"
                style="width: 200px"
              >
                <!-- 循环渲染选项 -->
                <el-option
                  v-for="grp in groupList"
                  :key="grp.id"
                  :label="grp.name"
                  :value="grp.id"
                ></el-option>
              </el-select>
            </template>
            <template v-else-if="item.key === 'description'">
                            <span v-if='!isEdit'>
                                {{ dioForm.description }}
                            </span>

              <el-input v-else type='textarea' v-model='areaValue' maxlength='250'
                        :autosize='{ minRows: 3, maxRows: 4 }' style='width:200px' show-word-limit></el-input>
            </template>

            <template v-else-if="item.key === 'nickname'">
                            <span v-if='!isEdit'>
                                {{ dioForm.nickname }}
                            </span>

              <el-input v-else type='text' v-model='nickname' style='width:200px' maxlength='30'></el-input>
            </template>
            <template v-else-if="item.key === 'carrierName'">
              <el-select v-model='currentCarrier' value-key='keycode'>
                <el-option :label='item.keycode' :value='item' :key='item.id'
                           v-for='item in detailObj.carrierRspList'></el-option>
              </el-select>
            </template>
            <template v-else-if="item.key === 'url'">
              <div>{{ currentCarrier.fullPath }}</div>
            </template>
            <template v-else>
              <span>{{ textChangeFn(item.key) }}</span>
            </template>

          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item v-if='isEdit'>
        <el-button type='primary' @click='saveDecFn'>
          <i class='el-icon-folder-checked button-icon '></i>
          {{ $t('public.save') }}
        </el-button>
        <el-button type='primary' @click='goBack'><i class='el-icon-refresh-left button-icon'></i>{{
            $t('integration.back') }}
        </el-button>
      </el-form-item>
      <el-form-item v-if='!isEdit'>
        <el-button type='primary' @click='goBack'><i class='el-icon-edit button-icon'></i>{{ $t('public.edit') }}
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { equiStatus, gatewayType } from '@/utils/convert'

export default {
  props: ['baseMsgArray', 'detailObj','deviceAssociate', 'isMode', 'coordinator','locationList','groupList'],
  watch: {
    detailObj: {
      handler (newVal) {
        this.dioForm = { ...newVal }
        if (this.detailObj.carrierRspList && this.detailObj.carrierRspList.length) { this.currentCarrier = this.detailObj.carrierRspList[0] }
      },
      immediate: true
    },
    deviceAssociate: {
      handler (newVal) {
        this.groupId = this.deviceAssociate?.groupId
        this.locationId = this.deviceAssociate?.locationId
      },
      immediate: true
    },
    isMode (newVal) {
      this.isEdit = newVal
      this.areaValue = this.detailObj.description
      this.nickname = this.detailObj.nickname
      this.dioForm.isHeart = this.detailObj.isHeart
      this.groupId = this.deviceAssociate?.groupId
      this.locationId = this.deviceAssociate?.locationId
    }
  },
  data () {
    return {
      dioForm: {},
      groupId: '',
      locationId: '',
      nickname: '',
      areaValue: '',
      isEdit: false,
      /** 配置状态 */
      configIconArray: [
        {
          value: 0,
          icon: 'el-icon-set-up',
          label: this.$t('device.wait_config')
        },
        {
          value: 1,
          icon: 'el-icon-connection',
          label: this.$t('device.configuring')
        },
        {
          value: 2,
          icon: 'el-icon-odometer',
          label: this.$t('device.configured')
        }
      ],
      currentCarrier: {},

    }
  },
  methods: {
    heartFn (key) {
      return this.dioForm[key] === 1 ? $t('public.btn_yes') : $t('public.btn_no')
    },
    TOODChange (value, array) {
      var param = ''
      for (const item of array) {
        if (item.value === value) {
          param = item.label
          break
        }
      }
      return param
    },
    selectChange (key, value) {
      if (key === 'location') {
        if (!value) {
          return ''
        }
        return this.TOODChange2(this.locationId, this.locationList)
      } else if (key === 'group') {
        if (!value) {
          return ''
        }
        return this.TOODChange2(this.groupId, this.groupList)
      }
    },
    TOODChange2 (value, array) {
      var param = ''
      for (const item of array) {
        if (item.id === value) {
          param = item.name
          break
        }
      }
      return param
    },
    textChangeFn (key) {
      const detailObj = this.dioForm

      switch (key) {
        case 'url': {
          return detailObj[key] === 'undefined/' ? detailObj.scopeName : detailObj[key]
        }
        case 'status': {
          // return detailObj[key] === 1 ? $t('integration.on-line') : $t('integration.off-line');
          return equiStatus[detailObj[key]] && equiStatus[detailObj[key]].title
        }
        case 'configStatus': {
          return this.TOODChange(detailObj[key], this.configIconArray)
        }
        case 'code': {
          return gatewayType[detailObj.type] && this.$t(gatewayType[detailObj.type].title)
        }
        case 'edited': {
          return detailObj[key] === 1 ? $t('public.btn_yes') : $t('public.btn_no')
        }
        case 'parameterStatus': {
          return detailObj[key] === 0 ? $t('integration.normal_reporting_data') : $t('integration.no_gateway_zigbee_parameter')
        }
        case 'createTime': {
          return this.$timetransition(detailObj[key])
        }
        case 'powerStatus': {
          return detailObj[key] === 0 ? this.$t('device.normal_power_supply') : this.$t('device.no_power_supply')
        }
        // case 'tcpStatus':
        //     {
        //         return detailObj[key] === 0 ? $t('integration.tcp_connection_service_exception') : $t('integration.tcp_connection_service_is_normal')
        //     }
        // case 'lteStatus':
        //     {
        //         return detailObj[key] === 0 ? $t('integration.lte_connection_server_exception') : $t('integration.lte_connection_server_is_normal')
        //     }
        // case 'flightMode':
        //     {
        //         return detailObj[key] === 0 ? $t('integration.not_in_flight_mode') : $t('integration.flight_mode')
        //     }

        default:
          break
      }
      return detailObj[key]
    },
    goBack () {
      this.areaValue = this.detailObj.description
      this.nickname = this.detailObj.nickname
      this.locationId = this.deviceAssociate?.locationId
      this.groupId = this.deviceAssociate?.groupId
      this.dioForm.isHeart = this.detailObj.isHeart
      this.$emit('update:isMode', !this.isMode)
    },
    saveDecFn () {
      const {
        id,
        isHeart
      } = this.dioForm
      this.$emit('saveDecFn', {
        id,
        isHeart,
        groupId:this.groupId,
        locationId:this.locationId,
        nickname: this.nickname,
        areaValue: this.areaValue
      })
    },

  }
}
</script>

<style lang='scss' scoped>
.list {
  flex: 1;
}

::v-deep .button-icon {
  margin: 0;
  color: white;
  font-size: 14px;
  font-weight: 100;
  margin-right: 5px;
}

.el-select {
  height: 28px;
}
</style>
